export const DisplayHonoraires = () => ({
  type: "DISPLAY_HONORAIRES",
});
